import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useEffect, useRef } from 'react';

import { useGetSeparateAddressesAutocomplete } from 'shared/api/daData';

import type { TPassportFormFields } from 'entities/creditForm';

export const useAutofillRegionFromResidence = (isMounted = false) => {
  const { watch, setValue } = useFormContext<TPassportFormFields>();
  const residenceAddress = watch('residenceAddress');
  const [getSeparateAddressesAutocomplete] = useGetSeparateAddressesAutocomplete();

  const isMountedRef = useRef(isMounted);

  const fillRegion = useCallback(
    async (residence: typeof residenceAddress) => {
      if (!residence) {
        setValue('region', null, { shouldValidate: false });
        return;
      }

      const search = Array.from(
        new Set(
          [
            residence?.data?.region_with_type,
            residence?.data?.city_with_type,
            residence?.data?.settlement_with_type,
          ].filter(Boolean),
        ),
      ).join(', ');

      if (!search) {
        return;
      }

      const response = await getSeparateAddressesAutocomplete(
        {
          query: search,
        },
        true,
      ).unwrap();

      const selectedRegion = response?.find((option) => option.value.trim() === search.trim());

      if (selectedRegion) {
        setValue('region', selectedRegion, { shouldValidate: true });
      }
    },
    [getSeparateAddressesAutocomplete, setValue],
  );

  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true;
      return;
    }

    fillRegion(residenceAddress);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [residenceAddress?.value]);
};
